// IconButton (drawing v2.6, screen 2, row Icon button): 38 by 38, radius 8,
// a 20px icon; 44 by 44 under 1024. Every icon-only button takes a required
// `label` that names the thing ("More actions for Chen household", never
// "More"); it is the aria-label, and the tooltip when the button is disabled.

import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from "react";
import { cx } from "./cx";

export interface IconButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "disabled" | "aria-label"> {
  /** The accessible name. Required. */
  label: string;
  icon: ReactNode;
  /** The bordered look (`.iconbtn.bd` in the drawing): a quick action on a row, a header's More. */
  bordered?: boolean;
  disabledReason?: string;
  /** Shown only on a phone (the header's More that holds Export). */
  showOnPhoneOnly?: boolean;
}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(function IconButton(
  { label, icon, bordered, disabledReason, showOnPhoneOnly, className, onClick, type, ...rest },
  ref,
) {
  const disabled = Boolean(disabledReason);
  return (
    <button
      ref={ref}
      type={type ?? "button"}
      className={cx("pg-iconbtn", bordered && "pg-iconbtn--bd", showOnPhoneOnly && "pg-show-p", className)}
      aria-label={label}
      aria-disabled={disabled || undefined}
      title={disabledReason ?? label}
      onClick={(e) => {
        if (disabled) {
          e.preventDefault();
          return;
        }
        onClick?.(e);
      }}
      {...rest}
    >
      {icon}
    </button>
  );
});
